/* cords2-cart.js: the bag drawer and the cart page's steppers. 24 October 2026.

   ADD IN PLACE. Every form posting to /cart/add (the buy panel, the sticky buy
   bar, the "Often bought with" rows) is caught here and sent to
   /cart/add.js instead, with the drawer requested in the same call (bundled
   section rendering, Shopify Ajax Cart API). The drawer is replaced with the
   server's HTML and opened. If anything fails before the server answers, the
   form is submitted the ordinary way and the shopper lands on /cart, which is
   what happens with no JavaScript at all.

   Everything is delegated from the document, because the drawer's markup is
   replaced after every change and scripts inside fetched HTML do not run.

   ON THE CART PAGE there is no drawer. The steppers change their input and
   submit the page's own form after a short pause, so a double tap is one
   request. */
(function () {
  var SECTION = 'cords2-cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var text = {};
  try { text = JSON.parse(document.querySelector('[data-c2-cart-text]').textContent); } catch (e) {}
  var lastTrigger = null;

  function drawer() { return document.querySelector('[data-c2-drawer]'); }

  function announce(msg) {
    var live = document.querySelector('[data-c2-cart-live]');
    if (!live || !msg) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  function setCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('.cords2-header__bag'), function (a) {
      var c = a.querySelector('.cords2-header__count');
      if (n > 0) {
        if (!c) {
          c = document.createElement('span');
          c.className = 'cords2-header__count';
          c.setAttribute('aria-hidden', 'true');
          a.appendChild(c);
        }
        c.textContent = n;
      } else if (c) {
        c.parentNode.removeChild(c);
      }
      var vh = a.querySelector('.visually-hidden');
      if (vh) vh.textContent = vh.textContent.replace(/\d+\s*$/, String(n));
    });
  }

  function render(html) {
    if (!html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-c2-drawer-inner]');
    var cur = document.querySelector('[data-c2-drawer-inner]');
    if (!fresh || !cur) return false;
    cur.parentNode.replaceChild(fresh, cur);
    /* Scripts inside HTML set by innerHTML never run. The express checkout
       buttons may bring theirs, so each is re-created to run once. */
    Array.prototype.forEach.call(fresh.querySelectorAll('script'), function (old) {
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
    /* The delivery date line is a [delivery] token, filled by cords2-deliver.js. */
    if (window.cords2Delivery) window.cords2Delivery.refresh();
    var n = parseInt(fresh.getAttribute('data-count'), 10);
    if (!isNaN(n)) setCount(n);
    return true;
  }

  function showError(msg) {
    var el = document.querySelector('[data-c2-cart-error]');
    if (!el) return;
    if (msg === '') { el.textContent = ''; el.hidden = true; return; }   /* clear */
    el.textContent = msg || text.error || '';
    el.hidden = !el.textContent;
  }

  function open(trigger) {
    var d = drawer();
    if (!d) return;
    lastTrigger = trigger || document.activeElement;
    if (!d.open) {
      d.showModal();
      document.documentElement.classList.add('c2-drawer-open');
    }
    var close = d.querySelector('[data-c2-drawer-close]');
    if (close) close.focus();
  }

  function close() {
    var d = drawer();
    if (d && d.open) d.close();
  }

  function busy(el, on) {
    if (!el) return;
    if (on) { el.setAttribute('aria-busy', 'true'); el.disabled = true; }
    else { el.removeAttribute('aria-busy'); el.disabled = false; }
  }

  function readJSON(r) {
    return r.json().then(function (j) { return { ok: r.ok, j: j }; });
  }

  /* Add to cart, anywhere on a cords2 page that has the drawer. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!drawer() || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);
    busy(btn, true);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(readJSON)
      .then(function (res) {
        if (!res.ok) {
          showError(res.j && (res.j.description || res.j.message));
          open(btn);
          return;
        }
        var html = res.j.sections && res.j.sections[SECTION];
        if (!render(html)) { window.location.href = root + 'cart'; return; }
        showError('');
        announce(text.added);
        open(btn);
      })
      .catch(function () { HTMLFormElement.prototype.submit.call(form); })
      .then(function () { busy(btn, false); });
  });

  /* MAKE IT A SET, 26 October 2026 (cords2-cart-cord). The set offer is a
     /cart/update form: the line one fewer and the set one more, in one call,
     so the bag never holds both or neither. Sent in place with the drawer
     rendered alongside, as the adds are. On the cart page, where there is no
     drawer, the form posts and the page reloads. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-c2-cord-swap]')) return;
    if (!drawer() || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var updates = {};
    Array.prototype.forEach.call(form.querySelectorAll('input[name^="updates["]'), function (i) {
      var k = i.getAttribute('data-key') || i.getAttribute('data-set');
      if (k) updates[k] = parseInt(i.value, 10) || 0;
    });
    busy(btn, true);
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTION, sections_url: window.location.pathname })
    })
      .then(readJSON)
      .then(function (res) {
        if (!res.ok) { showError(res.j && (res.j.description || res.j.message)); busy(btn, false); return; }
        if (!render(res.j.sections && res.j.sections[SECTION])) { window.location.href = root + 'cart'; return; }
        showError('');
        announce(text.added);
        var c = drawer() && drawer().querySelector('[data-c2-drawer-close]');
        if (c) c.focus();
      })
      .catch(function () { HTMLFormElement.prototype.submit.call(form); });
  });

  /* Change a line's quantity, or remove it, inside the drawer. */
  function change(line, qty, trigger) {
    busy(trigger, true);
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: SECTION, sections_url: window.location.pathname })
    })
      .then(readJSON)
      .then(function (res) {
        if (!res.ok) { showError(res.j && (res.j.description || res.j.message)); busy(trigger, false); return; }
        render(res.j.sections && res.j.sections[SECTION]);
        var c = drawer() && drawer().querySelector('[data-c2-drawer-close]');
        if (c) c.focus();
      })
      .catch(function () { busy(trigger, false); showError(text.error); });
  }

  document.addEventListener('click', function (e) {
    var d = drawer();

    /* The masthead's Bag mark opens the drawer, refreshed, instead of leaving. */
    var bag = e.target.closest('.cords2-header__bag');
    if (bag && d && window.fetch) {
      e.preventDefault();
      open(bag);
      fetch(root + '?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { render(j[SECTION]); })
        .catch(function () {});
      return;
    }

    if (!d) {
      /* Cart page steppers. */
      var pb = e.target.closest('[data-c2-page-qty]');
      if (!pb) return;
      var input = pb.parentNode.querySelector('input');
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(pb.getAttribute('data-c2-page-qty'), 10));
      input.value = v;
      var form = pb.closest('form');
      clearTimeout(form._c2t);
      form._c2t = setTimeout(function () {
        var u = form.querySelector('[data-c2-cart-update]');
        if (form.requestSubmit && u) form.requestSubmit(u); else form.submit();
      }, 450);
      return;
    }

    if (e.target.closest('[data-c2-drawer-close]')) { close(); return; }
    if (e.target === d) { close(); return; }   /* the backdrop */

    var q = e.target.closest('[data-c2-line-qty]');
    if (q && d.contains(q)) {
      var li = q.closest('[data-line]');
      var cur = parseInt(q.getAttribute('data-qty'), 10) || 0;
      change(parseInt(li.getAttribute('data-line'), 10), Math.max(0, cur + parseInt(q.getAttribute('data-c2-line-qty'), 10)), q);
      return;
    }

    var rm = e.target.closest('[data-c2-line-remove]');
    if (rm && d.contains(rm)) {
      e.preventDefault();
      change(parseInt(rm.closest('[data-line]').getAttribute('data-line'), 10), 0, null);
    }
  });

  /* A quantity typed on the cart page submits once the field is left. */
  document.addEventListener('change', function (e) {
    if (drawer()) return;
    var i = e.target;
    if (!i.matches || !i.matches('#c2-cart-form input[name="updates[]"]')) return;
    var form = i.form, u = form.querySelector('[data-c2-cart-update]');
    if (form.requestSubmit && u) form.requestSubmit(u); else form.submit();
  });

  var d0 = drawer();
  if (d0) {
    d0.addEventListener('close', function () {
      document.documentElement.classList.remove('c2-drawer-open');
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    });
  }

  /* The cart page hides its Update button once the steppers can do it. */
  var upd = document.querySelector('[data-c2-cart-update]');
  if (upd) upd.classList.add('is-js');
})();
